module.exports = __webpack_public_path__ + "static/media/Monday_Step2_Image13.6ae8adca.webp";